'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: The purpose of the service is for Vitals Info
//*******CREATED BY: Lakshmi B
//*******CREATED DATE: 10/30/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

angular.module('EMR.Vitals').service('VitalsCommonService', ['$http', 'CommonService', function ($http, CommonService) {
	//################### FUNCTION TO GET O2 UNITS STARTS #########################
	/// <summary>
	/// *******PURPOSE:THIS METHOD IS USED  TO GET O2 UNITS LIST
	///*******CREATED BY:AFROZ
	///*******CREATED DATE: 03/11/15
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.vitalsAddVitalInfoGetO2Units = function () {
		var postData = {
			practicemodel: EMRPracticeModel
		};
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Vitals() + "GetO2UnitsList", postData).then(
			function (result) {
				return result;
			});

	};
	//################### FUNCTION TO GET O2 UNITS ENDS #########################

	//################### FUNCTION TO GET TEMPERATURE UNITS STARTS #########################
	/// <summary>
	/// *******PURPOSE:THIS METHOD IS USED  TO GET TEMPERATURE UNITS LIST
	///*******CREATED BY:AFROZ
	///*******CREATED DATE: 03/11/15
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.vitalsAddVitalInfoGetTemperatureUnits = function () {
		var postData = {
			practicemodel: EMRPracticeModel
		};
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Vitals() + "GetTemperatureUnitsList", postData).then(
			function (result) {
				return result;
			});

	};
	//################### FUNCTION TO GET O2 UNITS ENDS #########################

	//################### FUNCTION TO GET O2 UNITS STARTS #########################
	/// <summary>
	/// *******PURPOSE:THIS METHOD IS USED  TO GET O2 UNITS LIST
	///*******CREATED BY:Durga Prasad V
	///*******CREATED DATE: 03/11/19
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.vitalsAddVitalInfoGetVitalsLKPData = function () {
		var postData = {
			practicemodel: EMRPracticeModel
		};
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Vitals() + "GetPatientVitalsLKPData", postData).then(
			function (result) {
				return result;
			});

	};
	//################### FUNCTION TO GET O2 UNITS ENDS #########################

	////###################  GET PATIENT VITAL FOR BMI INSTRUCTIONS  LAST GIVEN DATE BLOCK START #############################
	/// *******PURPOSE: THIS SERVICE IS USED TO GET PATIENT VITAL FOR BMI INSTRUCTIONS  LAST GIVEN DATE 
	///*******CREATED BY:RAVI CHANDRA TIRUNAGARI
	///*******CREATED DATE:10/10/2017
	this.vitalsServiceGetPatientBMIInstructionsLatestGivenDate = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Vitals() + "GetPatientBMIInstructionsLatestGivenDate", postData).then(function (result) { return result; });



	};
	////################### GET PATIENT VITAL FOR BMI INSTRUCTIONS  INFO LIST BLOCK END #############################

	////################### GET VITALS LIST WITH COLOR CODES BLOCK START #############################
	/// *******PURPOSE: THIS IS USED TO GET VITALS LIST WITH COLOR CODES
	///*******CREATED BY: Vijay B
	///*******CREATED DATE: 08/11/2017
	this.vitalsServiceGetVitalsListwithColorCodes = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Vitals() + "GetVitalsListwithColorCodesInformation", postData).then(function (result) { return result; });

	};
	////################### GET VITALS LIST WITH COLOR CODES BLOCK END #############################

}])